export const AUTHOR_TYPES = {
  AGENT: "AGENT",
  CUSTOMER: "CUSTOMER",
};

export const MESSAGE_TYPES = {
  TEXT: "TEXT",
  IMAGE: "IMAGE",
  VIDEO: "VIDEO",
  AUDIO: "AUDIO",
  DOCUMENT: "DOCUMENT",
  TEMPLATE: "TEMPLATE",
  BUTTON: "BUTTON",
  INTERACTIVE: "INTERACTIVE",
};

export const MESSAGE_STATUS = {
  QUEUED: "QUEUED",
  SENT: "SENT",
  DELIVERED: "DELIVERED",
  READ: "READ",
  FAILED: "FAILED",
};

export const MESSAGE_DIRECTION = {
  INBOUND: "INBOUND",
  OUTBOUND: "OUTBOUND",
};

export const CONVERSATION_STATUS = {
  OPEN: "OPEN",
  CLOSED: "CLOSED",
  ARCHIVED: "ARCHIVED",
};

export const CONVERSATION_TYPE = {
  LEAD: "LEAD",
  CUSTOMER: "CUSTOMER",
  SUPPORT: "SUPPORT",
};

export const CHANNELS = {
  WHATSAPP: "WHATSAPP",
  EMAIL: "EMAIL",
  SMS: "SMS",
};

export const CHAT_BACKGROUND_STYLE = {
  backgroundImage:
    'url("https://user-images.githubusercontent.com/15075759/28719144-86dc0f70-73b1-11e7-911d-60d70fcded21.png")',
  backgroundRepeat: "repeat",
  backgroundSize: "400px",
};

export const SENDER_TYPES = {
  CUSTOMER: "customer",
  ADMIN: "admin",
};
